import styled from "styled-components";
import { lighten } from "polished";

import { FormElement } from "../shared-style";

export const StyledCheckbox = styled(FormElement)`
    cursor: pointer;

    .CheckboxLabel {
        padding-left: 6px;
        font-size: 18px;
        font-weight: 300;
        cursor: pointer;
    }

    .CheckboxMark {
        vertical-align: -2px;
        width: 16px;
        height: 16px;
        box-sizing: border-box;
        border: ${p => p.theme.c.grey7} 1px solid;
        border-radius: 4px;
        display: inline-block;
        position: relative;
        flex-shrink: 0;

        svg {
            position: absolute;
            top: 0;
            left: 0;
            display: none;
            transform: scale(0.9);

            line,
            polygon {
                stroke: ${p => p.theme.c.snow};
                fill: none;
                stroke-width: 2px;
            }
        }

        &.CheckboxMarkChecked {
            background-color: ${p => p.theme.c.active};
            border-color: ${p => p.theme.c.active};
            svg {
                display: block;
            }
        }
    }

    &.CheckboxDisabled {
        pointer-events: none;

        .CheckboxMark {
            border-color: ${p => p.theme.c.disabled};

            &.CheckboxMarkChecked {
                background-color: ${p => p.theme.c.disabled};
            }
        }

        .CheckboxLabel {
            color: ${p => p.theme.c.disabled};
        }
    }

    &:hover {
        .CheckboxMark {
            border-color: ${p => p.theme.c.active};
        }
    }
    &:focus {
        .CheckboxMark {
            border-color: ${p => p.theme.c.active};
            box-shadow: 0 0 3px 0 ${p => p.theme.c.blackShadow4};
        }
        outline: 0;
    }

    &.Dark {
        color: ${p => p.theme.c.dark};
        .CheckboxLabel {
            font-weight: 600;
        }

        .CheckboxMark {
            border: ${p => lighten(0.05, p.theme.c.dark)} 1px solid;
            background-color: ${p => p.theme.c.dark};
            transition: 200ms;

            svg {
                line,
                polygon {
                    stroke: ${p => p.theme.c.boost};
                }
            }

            &.CheckboxMarkChecked {
                background-color: ${p => p.theme.c.whiteOnActive};
                border-color: ${p => p.theme.c.whiteOnActive};
                polygon {
                    stroke: ${p => p.theme.c.boost} !important;
                }
            }
        }

        &:hover {
            .CheckboxMark {
                border: ${p => p.theme.c.pale} 1px solid;
            }
        }
        &:focus {
            .CheckboxMark {
                border-color: ${p => p.theme.c.boost};
            }
        }
    }

    &.SelectCheckbox {
        padding: 8px;
        margin: 0;
    }
`;
